export default "__VITE_ASSET__DnVMYUm7__"